// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__50Ysy","content":"Tooltip_content__IFeY5","arrow":"Tooltip_arrow__d1aH0"};